import React, { useState, Children } from 'react';
import { ShieldCheckIcon, YoutubeIcon, LockIcon, CheckIcon, ExternalLinkIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BubbleButton } from './BubbleButton';
interface RequirementsPageProps {
  setIsAuthenticated: (value: boolean) => void;
}
export const RequirementsPage = ({
  setIsAuthenticated
}: RequirementsPageProps) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const navigate = useNavigate();
  const correctPassword = '78601';
  const handlePasswordSubmit = () => {
    if (password === correctPassword) {
      setError('');
      setShowSuccessMessage(true);
      // Store in localStorage that user has authenticated
      localStorage.setItem('wingoAuthComplete', 'true');
      // Update authentication state in parent component
      setIsAuthenticated(true);
      // Navigate to main app after showing success message
      setTimeout(() => {
        navigate('/prediction');
      }, 1500);
    } else {
      setError('Incorrect password. Please try again.');
    }
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1
    }
  };
  return <div className="w-full min-h-screen cyber-bg text-green-400 p-4 flex justify-center items-center grid-bg" data-id="element-42">
      <motion.div className="w-full max-w-md border border-green-500 p-6 rounded-lg bg-black shadow-lg animate-glow" initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      type: 'spring'
    }} data-id="element-43">
        <div className="flex items-center justify-between mb-6 border-b border-green-500 pb-2" data-id="element-44">
          <motion.div className="flex items-center" whileHover={{
          scale: 1.03
        }} data-id="element-45">
            <ShieldCheckIcon className="text-green-400 mr-2 animate-pulse-custom" size={24} data-id="element-46" />
            <h1 className="text-xl font-mono text-green-400" data-id="element-47">
              ACCESS REQUIREMENTS
            </h1>
          </motion.div>
          <div className="flex space-x-2" data-id="element-48">
            <motion.div whileHover={{
            scale: 1.2
          }} className="w-3 h-3 rounded-full bg-red-500" data-id="element-49"></motion.div>
            <motion.div whileHover={{
            scale: 1.2
          }} className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-50"></motion.div>
            <motion.div whileHover={{
            scale: 1.2
          }} className="w-3 h-3 rounded-full bg-green-500" data-id="element-51"></motion.div>
          </div>
        </div>
        {showSuccessMessage ? <motion.div className="text-center p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3
      }} data-id="element-52">
            <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1,
          rotate: [0, 10, -10, 0]
        }} transition={{
          duration: 0.6,
          type: 'spring',
          bounce: 0.5
        }} data-id="element-53">
              <CheckIcon size={50} className="text-green-500 mx-auto mb-4 animate-pulse-custom" data-id="element-54" />
            </motion.div>
            <motion.p className="text-green-400 font-mono text-lg" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} data-id="element-55">
              Access Granted!
            </motion.p>
            <motion.p className="text-green-400/70 font-mono text-sm mt-2" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.3
        }} data-id="element-56">
              Redirecting to prediction tool...
            </motion.p>
          </motion.div> : <>
            <motion.div className="mb-6" variants={containerVariants} initial="hidden" animate="visible" data-id="element-57">
              <motion.p className="text-green-400 font-mono mb-4" variants={itemVariants} data-id="element-58">
                Complete the following requirements to access the prediction
                tool:
              </motion.p>
              <motion.div className="space-y-4 mb-6" variants={containerVariants} data-id="element-59">
                <motion.div className="border border-green-500/50 p-3 rounded-lg hover:border-green-400 transition-colors" variants={itemVariants} whileHover={{
              scale: 1.02,
              boxShadow: '0 0 10px rgba(72, 255, 128, 0.3)'
            }} data-id="element-60">
                  <h2 className="font-mono text-green-400 mb-2 flex items-center" data-id="element-61">
                    <span className="inline-block w-6 h-6 rounded-full border border-green-400 text-center mr-2" data-id="element-62">
                      1
                    </span>
                    Join WhatsApp Channel
                  </h2>
                  <motion.a href="https://whatsapp.com/channel/0029VavSpfK65yDLOXndx12q" target="_blank" rel="noopener noreferrer" className="flex items-center text-green-400 hover:text-green-300 font-mono text-sm underline" whileHover={{
                x: 3
              }} transition={{
                type: 'spring',
                stiffness: 400,
                damping: 10
              }} data-id="element-63">
                    Join Channel <ExternalLinkIcon size={14} className="ml-1" data-id="element-64" />
                  </motion.a>
                </motion.div>
                <motion.div className="border border-green-500/50 p-3 rounded-lg hover:border-green-400 transition-colors" variants={itemVariants} whileHover={{
              scale: 1.02,
              boxShadow: '0 0 10px rgba(72, 255, 128, 0.3)'
            }} data-id="element-65">
                  <h2 className="font-mono text-green-400 mb-2 flex items-center" data-id="element-66">
                    <span className="inline-block w-6 h-6 rounded-full border border-green-400 text-center mr-2" data-id="element-67">
                      2
                    </span>
                    Subscribe to YouTube
                  </h2>
                  <motion.a href="https://youtube.com/@color_trader_expert?si=LSWeW3x5knn_7cyi" target="_blank" rel="noopener noreferrer" className="flex items-center text-green-400 hover:text-green-300 font-mono text-sm underline" whileHover={{
                x: 3
              }} transition={{
                type: 'spring',
                stiffness: 400,
                damping: 10
              }} data-id="element-68">
                    <YoutubeIcon size={14} className="mr-1" data-id="element-69" /> Subscribe to
                    Channel <ExternalLinkIcon size={14} className="ml-1" data-id="element-70" />
                  </motion.a>
                </motion.div>
                <motion.div className="border border-green-500/50 p-3 rounded-lg hover:border-green-400 transition-colors" variants={itemVariants} whileHover={{
              scale: 1.02,
              boxShadow: '0 0 10px rgba(72, 255, 128, 0.3)'
            }} data-id="element-71">
                  <h2 className="font-mono text-green-400 mb-2 flex items-center" data-id="element-72">
                    <span className="inline-block w-6 h-6 rounded-full border border-green-400 text-center mr-2" data-id="element-73">
                      3
                    </span>
                    Contact on WhatsApp
                  </h2>
                  <motion.a href="https://wa.link/pnuzd7" target="_blank" rel="noopener noreferrer" className="flex items-center text-green-400 hover:text-green-300 font-mono text-sm underline" whileHover={{
                x: 3
              }} transition={{
                type: 'spring',
                stiffness: 400,
                damping: 10
              }} data-id="element-74">
                    Contact for Support{' '}
                    <ExternalLinkIcon size={14} className="ml-1" data-id="element-75" />
                  </motion.a>
                </motion.div>
              </motion.div>
              <motion.div className="border border-green-500 p-4 rounded-lg animate-glow" variants={itemVariants} whileHover={{
            boxShadow: '0 0 15px rgba(72, 255, 128, 0.4)'
          }} data-id="element-76">
                <h2 className="font-mono text-green-400 mb-3 flex items-center" data-id="element-77">
                  <LockIcon size={18} className="mr-2 animate-pulse-custom" data-id="element-78" />
                  Enter Access Password
                </h2>
                <motion.input type="password" value={password} onChange={e => setPassword(e.target.value)} className="bg-black border border-green-500 text-green-400 font-mono p-2 w-full mb-2 focus:outline-none rounded terminal-glow" placeholder="Enter password" whileFocus={{
              boxShadow: '0 0 15px rgba(72, 255, 128, 0.7)'
            }} data-id="element-79" />
                {error && <motion.p className="text-red-500 text-sm font-mono mb-2" initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              type: 'spring',
              stiffness: 100
            }} data-id="element-80">
                    {error}
                  </motion.p>}
                <BubbleButton onClick={handlePasswordSubmit} className="w-full rounded" data-id="element-81">
                  VERIFY ACCESS
                </BubbleButton>
              </motion.div>
            </motion.div>
            <motion.div className="text-xs text-green-400/60 font-mono text-center mt-4" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} data-id="element-82">
              Note: You must complete all requirements to gain access.
            </motion.div>
          </>}
      </motion.div>
    </div>;
};